// OutOfCreditsModal.jsx
// Shown when an anonymous user has used all their free credits. Dismissible,
// but the input is blocked elsewhere — they can browse, just can't send.

import React from 'react';

export default function OutOfCreditsModal({ open, onClose, onSignIn }) {
  // TEMP: disabled so the layout is visible — re-enable by removing this line.
  return null;
  // eslint-disable-next-line no-unreachable
  if (!open) return null;
  return (
    <div className="ooc-modal__backdrop" onClick={onClose}>
      <div className="ooc-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Out of free credits">
        <button
          type="button"
          className="ooc-modal__close"
          onClick={onClose}
          aria-label="Close"
        >×</button>
        {/* Same two options Aria speaks at the usage wall — see
            services/planPolicy.js upgradeLine() and middleware/ariaUsageWall.js.
            If this modal is ever re-enabled it must not say something different
            from what she just said out loud: "Sign in or create an account"
            named neither the free tier, the price, nor what the price buys. */}
        <h2 className="ooc-modal__title">That's your free usage for now</h2>
        <p className="ooc-modal__body">
          A free account gives you more. $20 a month gets you the download,
          where Aria can work your screen herself.
        </p>
        <button
          type="button"
          className="ooc-modal__cta"
          onClick={onSignIn}
        >
          Create a free account
        </button>
        <button
          type="button"
          className="ooc-modal__dismiss"
          onClick={onClose}
        >
          Not now
        </button>
      </div>
    </div>
  );
}
